import $ from '@ali/tarzan-zepto';
import IScroll from 'iscroll';
import util from '../../../lib/util.js';
import BaseUI from '../../../component/baseui/index';
import tpl from './tpl.html';
import './style.scss';
import { getTranslation } from '../../../utils/index.js';
import EventBus from '../../context/eventbus.js';

const TAP = util.isPC() ? 'click' : 'tap';

const onOrderClickHandler = (ev) => {
  const $target = $(ev.currentTarget);
  const $wrapper = $target.closest('.order-list-wrap');

  if ($wrapper.data('selected')) {
    return;
  }
  $wrapper.data('selected', true);

  const orderId = $target.attr('data-order-id');
  const chatData = $wrapper.data('chatData');

  EventBus.emit('orderSelected', orderId, chatData);
};
const onNoneButtonClickHandler = (ev) => {
  const $target = $(ev.currentTarget);
  $target.off(TAP, onNoneButtonClickHandler);
  EventBus.emit('orderSelected');
};

function initScroll(orders, $node) {
  const prev = $node.find('.prev');
  const next = $node.find('.next');
  const order = $node.find('.J_Order');

  if (orders.length === 1) {
    next.hide();
  }

  $node.find('.J_Orderlist').css({
    // width: 274,
    maxHeight: 198,
  });

  $node.find('.J_Order').css({
    width: 218,
  });

  $node.find('.J_Scroller').css({ width: 230 * orders.length });

  const scroller = new IScroll($node.find('.J_Orderlist')[0], {
    scrollX: true,
    scrollY: false,
    momentum: false,
    snap: 'div.J_Order',
  });

  scroller.on('scrollEnd', () => {
    const len = scroller.pages.length;
    const index = scroller.currentPage.pageX;
    if (index === 0) {
      prev.hide();
      next.show();
    } else if (index === len - 1) {
      next.hide();
      prev.show();
    } else {
      prev.show();
      next.show();
    }
  });
  // 事件绑定
  next.on(TAP, () => scroller.next());
  prev.on(TAP, () => scroller.prev());
  order.on(TAP, onOrderClickHandler);
}

export default function orderSelector(data) {
  const orders = data.orders.map((item, index) => {
    item.orderTitleText = getTranslation('csc.order_selector.order_title', {
      index: index + 1,
      total: data.orders.length,
    });
    item.orderDetailText = getTranslation('csc.order_selector.order_number', { number: item.orderId });
    item.orderPlaceAtText = getTranslation('csc.order_selector.order_placed_at', { date: item.date });
    return item;
  });
  const $wrap = $('<div class="m-chatpanel-orderwrap"></div>');
  const tem = tpl.render({
    list: orders,
    orderSelectorTitleText: getTranslation('csc.order_selector.title', { total: orders.length }),
    btnOtherText: getTranslation('csc.order_selector.other'),
    chatData: JSON.stringify(data.messageData || {}),
  });
  const param = {
    name: 'orderselector',
    type: data.subType || '',
    mid: '11',
    content: tem,
  };
  const $node = $(BaseUI.msg(param));
  $node.find('.orderlist-none_of_above').on(TAP, onNoneButtonClickHandler);

  setTimeout(() => {
    $wrap.append($node);
    if (orders.length === 0) {
      this.view.body.scrollToBottom();
    } else {
      initScroll(orders, $wrap);
      this.view.body.scrollToBottom();
    }
  }, 0);

  return {
    body: $wrap,
    callback: () => {},
  };
}



// WEBPACK FOOTER //
// ./src/app/extension/orderselector/index.js